
import React, { useState, useEffect,} from 'react';
import { useDispatch } from 'react-redux';

import { hideForm } from 'services/forms';
import { useConfirmClosingForm } from '@/lib/modal';
import { showToast } from 'services/toasts';

const useForm = ({ id, getLazy = () => {}, updateMutation, createMutation, deleteMutation, dataFieldName = "data", defaultValues = {}}) => {

  const dispatch = useDispatch();
  const [trigger, { data, isLoading: isDataLoading}] = getLazy();


  const confirmClosingUnsavedForm = useConfirmClosingForm();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    console.info("triggering effect data, dataFieldName");
    if (data) {
      if (data[dataFieldName]) {
        setItem(data[dataFieldName]);
      }
    }
  }, [data, dataFieldName]);

  useEffect(() => {
    console.info("triggering effect isDataLoading, id");
    if (id !== 'new') {
      setIsLoading(isDataLoading);
    }
  }, [isDataLoading, id]);


  const [stateItem, setItem] = useState({model: {ID: 'new'},...defaultValues});
  const [unsaved, setUnsaved] = useState(false);

  useEffect(() => {
    console.info("triggering effect id, trigger");
    if (id === 'new') {
      setIsLoading(false);
    } else {
      trigger(id);
    }
  }, [id, trigger]);

  /**
   * callback if a field in the form gets changed
   *
   * @param {any} field the name of the changed field
   * @param {any} value the new value of the changed field
   */
  const onChangeField = (field, value) => {
    console.info("triggering on change field field:", field, " value:", value);
    if (typeof field === 'object') {
      if (field.length === 1) {
        setItem(prev => ({
          ...prev,
          [field[0]]: value,
        }));
      }

      if (field.length === 2) {
        setItem(prev => ({
          ...prev,
          [field[0]]: {
            ...prev[field[0]],
            [field[1]]: value,
          },
        }));
      }

      if (field.length === 3) {
        setItem(prev => ({
          ...prev,
          [field[0]]: {
            ...prev[field[0]],
            [field[1]]: {
              ...prev[field[0]][field[1]],
              [field[2]]: value,
            },
          },
        }));
      }
    } else {
      setItem(prev => ({
        ...prev,
        [field]: value,
      }));
    }

    setUnsaved(true);
  };

  useEffect(() => {
    console.info("item changed:", stateItem);
  }, [stateItem]);

  const onCloseForm = () => {
    if (unsaved === true) {
      confirmClosingUnsavedForm(() => dispatch(hideForm()));
    } else {
      dispatch(hideForm());
    }
  }

  // The SideForm button hands its onClick over as `onSaveRequest`, so the
  // first argument is the React MouseEvent — not a callback. Treat anything
  // non-function as "no callback" so callback(true) doesn't blow up.
  const onSaveRequest = (cb) => {
    const callback = typeof cb === 'function' ? cb : () => {};

    // Best-effort extraction of a user-visible error caption out of whatever
    // shape RTK Query / the axios baseQuery rejects with. Walks through the
    // common shapes but always returns a *string* — otherwise interpolating
    // an object into the toast caption renders as "[object Object]" or
    // blows up with React #31 once Carbon tries to render the object child.
    const errorCaption = (e) => {
      if (!e) return 'unbekannt';
      if (typeof e === 'string') return e;
      const candidates = [
        e?.data?.message,
        e?.data?.msg,
        e?.payload?.data?.message,
        e?.payload?.data?.msg,
        typeof e?.payload?.data === 'string' ? e.payload.data : null,
        typeof e?.data === 'string' ? e.data : null,
        e?.message,
      ];
      for (const c of candidates) {
        if (typeof c === 'string' && c.length > 0) return c;
      }
      return 'unbekannt';
    };

    if (id === 'new') {
      // it is not new, so we want to update it
      let createItem = {...stateItem, model: null};
      // Use the two-argument .then(onFulfilled, onRejected) form so an
      // exception inside the success branch (e.g. callback() blowing up)
      // doesn't accidentally trigger the error toast too.
      createMutation(createItem).unwrap().then(
        (res) => {
          dispatch(showToast({kind: 'success', title: 'Daten gespeichert', subtitle: 'Die Daten wurde erfolgreich angelegt.'}))
          setUnsaved(false);
          dispatch(hideForm());
          callback(true);
        },
        (rejectError) => {
          dispatch(showToast({kind: 'error', title: 'Fehler beim bearbeiten', subtitle: `Beim Versuch die Daten zu speichern ist ein Fehler aufgetreten.(${errorCaption(rejectError)})`}))
          callback(false);
        }
      );
    } else {
      updateMutation({id: id, form: stateItem }).unwrap().then(
        (res) => {
          dispatch(showToast({kind: 'success', title: 'Daten gespeichert', subtitle: 'Die Daten wurden erfolgreich gespeichert.'}))
          setUnsaved(false);
          dispatch(hideForm());
          callback(true);
        },
        (rejectError) => {
          console.info(rejectError);
          dispatch(showToast({kind: 'error', title: 'Fehler beim Speichern', subtitle: `Die Daten konnten nicht gespeichert werden.(${errorCaption(rejectError)})`}))
          callback(false);
        }
      );
    }
  }

  return {item: stateItem, onChangeField, onSaveRequest, onCloseForm, unsaved, loading: isLoading};
}

export default useForm;
